import React, { useEffect, useState } from 'react'
import CalculationDetail from '../../components/CalculationDetail'
import CalculationDetailWrap from '../../components/CalculationDetail/CalculationDetailWrap'
import { EMPTY_VALUE_DASH } from '../../constants'
import { AccountDetails } from '../../types'
import { numberToDollars } from '../../utils'
import { helpText } from './constants'
import { getBuyingPower } from './helpers/getBuyingPower'
import { getNetAmountString } from './helpers/getNetAmount'
import { getPrincipalAmountString } from './helpers/getPrincipalAmount'
import { isBuy } from './helpers/isBuy'
import { CurrencyEnum, TradeFormValues } from './Types'

export interface TradeCalculationsProps {
  values: TradeFormValues
  accountDetails?: AccountDetails
}

export const TradeCalculations = ({ values, accountDetails }: TradeCalculationsProps) => {
  const [buyingPower, setBuyingPower] = useState<string>('loading')
  const accountNumber = accountDetails?.accountNumber
  useEffect(() => {
    if (accountNumber) {
      setBuyingPower('loading')
      getBuyingPower(accountNumber)
        .then(overnightBuyingPower => {
          setBuyingPower(numberToDollars(overnightBuyingPower))
        })
        .catch(() => {
          setBuyingPower('N/A')
        })
    }
  }, [accountNumber])

  return (
    <CalculationDetailWrap>
      <CalculationDetail
        label={'Principal Amount'}
        value={getPrincipalAmountString(values)}
        helperText={helpText.principalAmount}
      />
      <CalculationDetail
        label={`Net ${(values.action && (isBuy(values.action) ? 'Debit' : 'Proceeds')) || EMPTY_VALUE_DASH}`}
        value={getNetAmountString(values)}
        helperText={helpText.netAmount}
      />
      <CalculationDetail
        label={'Buying Power'}
        value={`${values.currency === CurrencyEnum.cad ? 'US' : ''}${buyingPower}`}
        loading={buyingPower === 'loading'}
        helperText={helpText.buyingPower}
      />
    </CalculationDetailWrap>
  )
}

export default TradeCalculations
